import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { MaterialesService } from './../../../../../../../../services/API/materiales/materiales.service';
import { CamionesService } from './../../../../../../../../services/API/camiones/camiones.service';
import { UsersService } from './../../../../../../../../services/API/users/users.service';
import { AuthService } from './../../../../../../../../services/API/auth/auth.service';

@Component({
    selector: 'app-edit-registro-admin',
    templateUrl: './edit-registro-admin.component.html',
    styleUrls: ['./edit-registro-admin.component.css'],
    standalone: false
})
export class EditRegistroAdminComponent implements OnInit {

  showProgressBar: boolean = true;
  form: UntypedFormGroup;
  id: number = -1;
  fecha: any = "";
  fechaFinal: any = "";
  hora: string = "";
  usuario: number = -1;
  peso: number = -1;
  readonlyPeso: boolean = true;
  descripcion: string = "";
  camiones: any = [];
  usuarios: any = [];
  matricula: number = -1;
  nAlbaran: string = "";
  materiales: any = [];
  material: number = -1;
  recived: number = 0;
  saveDisabled: boolean = true;

  constructor(private fb: UntypedFormBuilder, public authService: AuthService, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<EditRegistroAdminComponent>
              , private camionesService: CamionesService, private materialesService: MaterialesService, private usersService: UsersService) { }

  ngOnInit(): void {
    this.userRolCheck('permiso_registrosDatos');
    this.userRolCheck2('permiso_registrosPesos');
    this.getUsuarios();
    this.getCamiones();
    this.getMateriales();

    this.id = parseInt(this.data['id'], 10);
    this.matricula = Number(this.data['id_camion']);
    this.material = Number(this.data['id_material']);
    this.nAlbaran = this.data['albaran'];
    this.descripcion = this.data['descripcion'];
    this.usuario = Number(this.data['id_usuario']);
    this.peso = this.data['peso'];
    this.fecha = this.data['fecha'];

    var date = (this.data['fecha'].replace("-", "/")).replace("-", "/");
    date = date.split(/\//);
    date = [ date[1], date[0], date[2] ].join('/');
    this.fecha = new Date(date);
    this.fechaFinal = this.data['fecha'];

    this.hora = this.formatHora(this.data['hora']);

    const pesoValidators = this.readonlyPeso
      ? []
      : [Validators.required, Validators.minLength(1), Validators.maxLength(256), Validators.pattern("^[0-9]*$")];

    this.form = this.fb.group({
      matricula: [this.matricula, [Validators.required]],
      nAlbaran: [this.nAlbaran, [Validators.required, Validators.minLength(1), Validators.maxLength(256), Validators.pattern("^[0-9]*$")]],
      material: [this.material, [Validators.required]],
      usuario: [this.usuario, [Validators.required]],
      descripcion: [this.descripcion, [Validators.maxLength(512)]],
      peso: [this.peso, pesoValidators],
      fecha: [this.fecha, [Validators.maxLength(128)]],
      hora: [this.hora, [Validators.required]],
    });

    this.form.controls['matricula'].setValue(this.matricula);
    this.form.controls['material'].setValue(this.material);
    this.form.controls['nAlbaran'].setValue(this.nAlbaran);
    this.form.controls['descripcion'].setValue(this.descripcion);
    this.form.controls['usuario'].setValue(this.usuario);
    this.form.controls['peso'].setValue(this.peso);
    this.form.controls['hora'].setValue(this.hora);

  }

  private formatHora(hora: string): string {
    if (!hora) {
      return '';
    }
    const parts = hora.split(':');
    if (parts.length >= 2) {
      return `${parts[0]}:${parts[1]}`;
    }
    return hora;
  }

  private getSegundos(hora: string): string {
    const parts = (hora || '').split(':');
    if (parts.length >= 3 && parts[2] !== '') {
      return parts[2].padStart(2, '0').slice(0, 2);
    }
    return '00';
  }

  /** Conserva los segundos originales; si la hora cambió y eran 00, genera unos aleatorios. */
  private formatHoraConSegundos(hora: string): string {
    const hhmm = this.formatHora(hora);
    if (!hhmm) {
      return '';
    }
    const originalHhmm = this.formatHora(this.data['hora']);
    let segundos = this.getSegundos(this.data['hora']);
    if (hhmm !== originalHhmm && segundos === '00') {
      segundos = String(Math.floor(Math.random() * 59) + 1).padStart(2, '0');
    }
    return `${hhmm}:${segundos}`;
  }

  private onCatalogsLoaded(): void {
    this.recived++;
    if (this.recived === 3) {
      this.showProgressBar = false;
      this.saveDisabled = false;
      if (this.form) {
        this.form.controls['usuario'].setValue(this.usuario);
        this.form.controls['matricula'].setValue(this.matricula);
        this.form.controls['material'].setValue(this.material);
      }
    }
  }

  userRolCheck(permission: string){
    if(!this.authService.userRolCheck(permission)) {
      this.authService.logout();
    }
  }

  userRolCheck2(permission: string){
    if(this.authService.userRolCheck(permission)) {
      this.readonlyPeso = false;
    }else{
      this.readonlyPeso = true;
    }
  }

  getUsuarios() {
    this.usersService.getUsuarios('all').subscribe(result => {
      this.usuarios = result;
      this.onCatalogsLoaded();
    });
  }

  getCamiones() {
    this.showProgressBar = true;
    this.camionesService.getCamiones('true').subscribe(result => {
      this.camiones = result;
      this.onCatalogsLoaded();
    });
  }

  getMateriales() {
    this.showProgressBar = true;
    this.materialesService.getMateriales('Pesaje').subscribe(result => {
      this.materiales = result;
      this.onCatalogsLoaded();
    });
  }

  dateChange(event: any){
    let fecha: any = new Date(event.target.value);
    fecha = fecha.getDate()+"-"+(fecha.getMonth()+1)+"-"+fecha.getFullYear();
    this.fechaFinal = fecha;
  }

  save() {
    const {value, valid} = this.form;
    if (valid) {
      value.hora = this.formatHoraConSegundos(value.hora);
      Object.assign(value, {"fechaFinal": this.fechaFinal});
      this.dialogRef.close(value);
      return;
    }
    this.form.markAllAsTouched();
  }

  close() {
    this.dialogRef.close();
  }

}
